import $ from 'jquery';

export default () => {
    var $open_menu_sparkasse = $('#open-menu-sparkasse');
    if ($open_menu_sparkasse.length > 0) {
        $open_menu_sparkasse.on('click', function () {
            console.log('click');
            if ($('body').attr('class').indexOf('show-sparkasse-menu') >= 0) {
                $('body').removeClass('show-sparkasse-menu');
            } else {
                $('body').addClass('show-sparkasse-menu');
            }
        });
    }
};



// WEBPACK FOOTER //
// ../views/header/header.js